import type { ProfileCustomization } from '@perplexicon/api-client';

import type { ProfileThemePreset } from '../../profile/profile-assets.js';

/**
 * Which theme preset (if any) the current draft's three cosmetic slots
 * exactly match. Presets are a write-only convenience (`profile-assets.ts`):
 * applying one fills three fields the user can then change independently, so
 * there is no stored "applied preset" — a preset only reads as selected while
 * every one of its fields still matches. Changing a single piece afterwards
 * simply stops any card from reading as selected, rather than showing a
 * partial/approximate match that doesn't exist anywhere else in the app.
 */
export function matchedPresetId(
  customization: Pick<
    ProfileCustomization,
    'avatarFrameId' | 'heroBackgroundId' | 'sideDecorationId'
  >,
  presets: readonly ProfileThemePreset[],
): string | null {
  const match = presets.find(
    (preset) =>
      preset.avatarFrameId === customization.avatarFrameId &&
      preset.heroBackgroundId === customization.heroBackgroundId &&
      preset.sideDecorationId === customization.sideDecorationId,
  );
  return match?.id ?? null;
}
